export const userMapper = new Map()
    .set("King Bhella of Arodene 👑", "Saneet Bhella")
    .set("Ethan Long Hair the Wise", "HART E")
    .set("Below Deck Alex 🚢", "Alexander Hayton")
    .set("Prince Andrew", "STANSFIELD AM T")
    .set('Jordan "Wolves Till I Die" From Scotland', "Bendstrup-Charlton Jordan")
    .set('George "ITFC 💩" Topper', "G Topper");
